import AdminNavbar from "@/components/AdminNavbar/AdminNavbar";
import { Button } from "@/components/ui/button";
import { SimpleAssessment } from "@/schema/console/simple-assessments/SimpleAssessment";
import CreateTestButton from "@/src/console/(auth)/(manage-assessments)/simple-assessments/_components/CreateTestButton";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface HeadingProps {
  draftTest?: SimpleAssessment;
  currentActiveTest?: SimpleAssessment;
}

function Heading({ draftTest, currentActiveTest }: HeadingProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const breadcrumbs = [
    {
      name: t("simple-assessment-title"),
      href: "/console/simple-assessment",
    },
  ];
  const hasDraft = !!draftTest;

  return (
    <div>
      <AdminNavbar breadcrumbs={breadcrumbs} />
      <div className="mx-6 my-8 flex justify-between">
        <div className="my-heading">{t("simple-assessment-title")}</div>
        {hasDraft ? (
          <Button
            onClick={() =>
              navigate(`/console/simple-assessments/create?duplicate=true`)
            }
          >
            {t("continue-editing-draft")}
          </Button>
        ) : (
          <CreateTestButton currentActiveTest={currentActiveTest} />
        )}
      </div>
      {hasDraft && (
        <div className="my-card mx-6 my-8 p-5">
          <div className="font-medium text-cool-gray-900">
            {t("simple-assessment-draft")}
          </div>
          <div className="text-cool-gray-600">
            {t("last-edited")}{" "}
            {format(new Date(draftTest.created_at), t("date-time-format"))}{" "}
            {t("by")} {draftTest.created_by.name}
          </div>
        </div>
      )}
    </div>
  );
}

export default Heading;
